module.exports = __webpack_public_path__ + "img/red-bottom.bba4ace8.png";